// src/pages/WriterDashboard.js
import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Alert,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Badge,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  CircularProgress,
  TextField,
  LinearProgress,
  alpha,
  useTheme,
  styled,
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
  Stepper,
  Step,
  StepLabel,
  ListItemIcon,
} from '@mui/material';
import {
  Assignment,
  Person,
  Message,
  Dashboard,
  CheckCircle,
  PendingActions,
  AccessTime,
  Download,
  Visibility,
  Edit,
  Refresh,
  Email,
  AssignmentTurnedIn,
  Work,
  Warning,
  DoneAll,
  PersonOff,
  Cancel,
  List as ListIcon,
  AttachMoney,
  TrendingUp,
  TrendingDown,
  MoreVert,
  Schedule,
  Description,
  School,
  Payment,
  Chat,
  Notifications,
  AccountCircle,
  ArrowForward,
  Star,
  InsertDriveFile,
  CloudUpload,
  RateReview,
  Update,
  ExpandMore,
  CloudDownload,
  AttachFile,
  CalendarToday,
  Language,
  FormatSize,
  LineStyle,
  Slideshow,
  Source,
  StarHalf,
  StarBorder,
  StarRate,
  TextSnippet,
  NoteAdd,
  Notes,
  Comment,
  Feedback,
  History,
  InsertDriveFile as InsertDriveFileIcon,
  PictureAsPdf,
  Image,
  VideoFile,
  AudioFile,
  Archive,
  Folder,
  FileCopy,
  Check,
  Close,
  Circle,
  ExpandCircleDown,
  ArrowRightAlt,
  Receipt,
  Timeline,
  CreditCard,
  HourglassEmpty,
  HourglassFull,
  Speed,
  Alarm,
  Timer,
  CalendarMonth,
  Event,
  EventAvailable,
  EventBusy,
  AccessAlarm,
  Timelapse,
  WatchLater,
  ScheduleSend,
  Send,
  MarkEmailRead,
  Markunread,
  Drafts,
  PictureAsPdf as PictureAsPdfIcon,
  Image as ImageIcon,
  Collections,
  BrokenImage,
  ImageNotSupported,
  NoPhotography,
  CameraFront,
  CameraRear,
  FlipCameraAndroid,
  FlipCameraIos,
  RotateRight,
  RotateLeft,
  Transform,
  CropRotate,
  FilterNone,
  Filter1,
  Filter2,
  Filter3,
  Filter4,
  Filter5,
  Filter6,
  Filter7,
  Filter8,
  Filter9,
  Filter9Plus,
  FilterBAndW,
  FilterCenterFocus,
  FilterDrama,
  FilterFrames,
  FilterHdr,
  FilterNone as FilterNoneIcon,
  FilterTiltShift,
  FilterVintage,
  Gradient,
  Grain,
  GridOff,
  HdrOff,
  HdrOn,
  HdrStrong,
  HdrWeak,
  Healing,
  Looks,
  Looks3,
  Looks4,
  Looks5,
  Looks6,
  LooksOne,
  LooksTwo,
  Loupe,
  MonochromePhotos,
  MusicNote,
  Nature,
  NaturePeople,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  Palette,
  PanTool,
  PhotoAlbum,
  PhotoFilter,
  PhotoLibrary,
  PhotoSizeSelectActual,
  PhotoSizeSelectLarge,
  PhotoSizeSelectSmall,
  Portrait,
  RawOn,
  ReceiptLong,
  RemoveRedEye,
  Rotate90DegreesCcw,
  ShutterSpeed,
  Square,
  Style,
  SwitchCamera,
  SwitchVideo,
  TagFaces,
  Texture,
  Timelapse as TimelapseIcon,
  Timer10,
  Timer3,
  TimerOff,
  Tonality,
  TouchApp,
  Transform as TransformIcon,
  Tune,
  ViewComfy,
  ViewCompact,
  Vignette,
  WbAuto,
  WbCloudy,
  WbIncandescent,
  WbIridescent,
  WbSunny,
  ZoomOutMap,
} from '@mui/icons-material';
import { 
  fetchOrders,
  writerOrderAction,
  submitWork,
  downloadFile,
  downloadOrderFile,
} from '../api/api';
import { format } from 'date-fns';

// Import the MessagingCenter component
import MessagingCenter from '../components/messaging/MessagingCenter';

// ===== STYLED COMPONENTS =====
const DashboardContainer = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
  minHeight: '100vh',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
}));

const DashboardHeader = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3, 4),
  marginBottom: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
  border: '1px solid #e5e7eb',
  backgroundColor: 'white',
}));

const MainTabsContainer = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
  border: '1px solid #e5e7eb',
  overflow: 'hidden',
  marginBottom: theme.spacing(3),
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: '#f8fafc',
  borderBottom: '1px solid #e5e7eb',
  padding: '0 16px',
  minHeight: 56,
  
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '15px',
    color: '#64748b',
    minHeight: 56,
    padding: '16px 24px',
    transition: 'all 0.2s ease',
    
    '&:hover': {
      color: '#08CB00',
      backgroundColor: alpha('#08CB00', 0.05),
    },
    
    '&.Mui-selected': {
      color: '#08CB00',
      backgroundColor: 'white',
      fontWeight: 600,
      position: 'relative',
      
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 3,
        background: '#08CB00',
        borderRadius: '3px 3px 0 0',
      },
    },
    
    '& .MuiTab-iconWrapper': {
      fontSize: 20,
      marginRight: theme.spacing(1),
    },
  },
}));

const StyledTab = styled(Tab)({});

const ContentPanel = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 4),
  backgroundColor: 'white',
}));

const StatCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  border: '1px solid #e5e7eb',
  boxShadow: 'none',
  height: '100%',
  transition: 'all 0.3s ease',
  
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
  },
}));

const SectionCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  border: '1px solid #e5e7eb',
  boxShadow: 'none',
  height: '100%',
}));

const PrimaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#08CB00',
  color: 'white',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  padding: '8px 20px',
  borderRadius: 8,
  border: '1px solid #08CB00',
  transition: 'all 0.2s ease',
  
  '&:hover': {
    backgroundColor: '#07B300',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(8, 203, 0, 0.2)',
  },
}));

const OutlineButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'white',
  color: '#08CB00',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  padding: '8px 20px',
  borderRadius: 8,
  border: '1px solid #08CB00',
  transition: 'all 0.2s ease',
  
  '&:hover': {
    backgroundColor: '#F0FFF0',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(8, 203, 0, 0.1)',
  },
}));

const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 650,
  
  '& .MuiTableCell-head': {
    backgroundColor: '#f8fafc',
    color: '#64748b',
    fontWeight: 600,
    fontSize: '13px',
    borderBottom: '2px solid #e5e7eb',
    whiteSpace: 'nowrap',
    padding: 16,
  },
  
  '& .MuiTableCell-body': {
    color: '#1e293b',
    fontSize: '14px',
    borderBottom: '1px solid #f1f5f9',
    padding: 16,
  },
  
  '& .MuiTableRow-root:hover': {
    backgroundColor: '#f8fafc',
  },
}));

const StatusTabsContainer = styled(Paper)(({ theme }) => ({
  backgroundColor: '#f8fafc',
  borderRadius: 8,
  border: '1px solid #e5e7eb',
  marginBottom: theme.spacing(3),
  overflow: 'hidden',
}));

const StatusTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 48,
  
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    color: '#64748b',
    minHeight: 48,
    padding: '12px 16px',
    transition: 'all 0.2s ease',
    
    '&:hover': {
      backgroundColor: alpha('#08CB00', 0.05),
      color: '#08CB00',
    },
    
    '&.Mui-selected': {
      backgroundColor: 'white',
      color: '#08CB00',
      fontWeight: 600,
      position: 'relative',
      
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 3,
        background: '#08CB00',
      },
    },
  },
}));

const TabCount = styled(Box)(({ theme }) => ({
  backgroundColor: '#e5e7eb',
  color: '#64748b',
  fontSize: '12px',
  fontWeight: 600,
  padding: '2px 8px',
  borderRadius: 12,
  minWidth: 24,
  textAlign: 'center',
  
  '.Mui-selected &': {
    backgroundColor: '#08CB00',
    color: 'white',
  },
}));

const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 12,
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
  },
}));

const DeadlineChip = styled(Chip)(({ theme, urgency }) => ({
  marginTop: theme.spacing(0.5),
  ...(urgency === 'critical' && {
    backgroundColor: '#fee2e2',
    color: '#dc2626',
    border: '1px solid #fecaca',
  }),
  ...(urgency === 'high' && {
    backgroundColor: '#fef3c7',
    color: '#d97706',
    border: '1px solid #fde68a',
  }),
  ...(urgency === 'medium' && {
    backgroundColor: '#fef9c3',
    color: '#ca8a04',
    border: '1px solid #fef08a',
  }),
  ...(urgency === 'normal' && {
    backgroundColor: '#dcfce7',
    color: '#16a34a',
    border: '1px solid #bbf7d0',
  }),
}));

// ===== MAIN COMPONENT =====
const WriterDashboard = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalOrders: 0,
    pendingOrders: 0,
    assignedOrders: 0,
    inProgressOrders: 0,
    submittedOrders: 0,
    completedOrders: 0,
    revisionOrders: 0,
    totalEarnings: 0,
    avgRating: 4.8,
    onTimeDelivery: 95,
  });

  // Order details dialog state
  const [orderDetails, setOrderDetails] = useState({
    open: false,
    order: null,
  });

  // Work submission state
  const [submitWorkData, setSubmitWorkData] = useState({
    open: false,
    orderId: null,
    orderTitle: '',
    completedWork: null,
    writerNotes: '',
    isSubmitting: false,
  });

  // Snackbar for notifications
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success', // 'success', 'error', 'warning', 'info'
  });

  // Status tabs for orders section
  const statusTabs = [
    { label: 'All', value: 'ALL', icon: <ListIcon />, color: '#666' },
    { label: 'Pending', value: 'PENDING', icon: <PendingActions />, color: '#FF9800' },
    { label: 'Assigned', value: 'ASSIGNED', icon: <Assignment />, color: '#2196F3' },
    { label: 'In Progress', value: 'IN_PROGRESS', icon: <Work />, color: '#4A6FA5' },
    { label: 'Submitted', value: 'SUBMITTED', icon: <AssignmentTurnedIn />, color: '#9C27B0' },
    { label: 'Completed', value: 'COMPLETED', icon: <CheckCircle />, color: '#4CAF50' },
    { label: 'Revision', value: 'REVISION', icon: <Warning />, color: '#F44336' },
  ];

  const [activeStatusTab, setActiveStatusTab] = useState(0);

  const tabs = [
    { label: 'Dashboard', icon: <Dashboard /> },
    { label: 'My Orders', icon: <Assignment /> },
    { label: 'Available Orders', icon: <Assignment /> },
    { label: 'Messages', icon: <Message /> },
  ];

  // Check user role on mount
  useEffect(() => {
    const checkUserRole = () => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      console.log("👤 Writer user from localStorage:", user);
      
      if (user.role !== 'WRITER') {
        alert("You need to be logged in as a writer to access this page.");
      }
    };
    
    checkUserRole();
  }, []);

  // Fetch all data
  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      
      // Fetch orders
      const ordersResponse = await fetchOrders();
      // Filter orders for this writer (simulated)
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      const writerOrders = ordersResponse.filter(order => 
        order.assigned_to === currentUser.id || 
        order.writer_username === currentUser.username
      );
      setOrders(writerOrders);
      
      // Calculate statistics
      calculateStats(writerOrders);
      
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      showSnackbar(`Failed to load dashboard: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const calculateStats = (ordersData) => {
    const totalOrders = ordersData.length;
    const pendingOrders = ordersData.filter(o => o.status === 'PENDING').length;
    const assignedOrders = ordersData.filter(o => o.status === 'ASSIGNED').length;
    const inProgressOrders = ordersData.filter(o => o.status === 'IN_PROGRESS').length;
    const submittedOrders = ordersData.filter(o => o.status === 'SUBMITTED').length;
    const completedOrders = ordersData.filter(o => o.status === 'COMPLETED').length;
    const revisionOrders = ordersData.filter(o => o.status === 'REVISION').length;
    
    const totalEarnings = ordersData
      .filter(o => o.status === 'COMPLETED')
      .reduce((sum, order) => sum + parseFloat(order.budget || 0), 0);
    
    // Mock performance stats
    const avgRating = 4.8;
    const onTimeDelivery = completedOrders > 0 ? 
      Math.min(95 + Math.random() * 5, 100) : 95;
    
    setStats({
      totalOrders,
      pendingOrders,
      assignedOrders,
      inProgressOrders,
      submittedOrders,
      completedOrders,
      revisionOrders,
      totalEarnings,
      avgRating,
      onTimeDelivery,
    });
  };

  const handleAcceptOrder = async (orderId) => {
    try {
      console.log(`✅ Accepting order ${orderId}...`);
      
      // Use the new writerOrderAction function
      await writerOrderAction(orderId, 'accept');
      
      showSnackbar("Order accepted successfully! Status changed to 'In Progress'.", 'success');
      fetchDashboardData();
      
    } catch (error) {
      console.error('Error accepting order:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Unknown error';
      showSnackbar(`Failed to accept order: ${errorMessage}`, 'error');
    }
  };

  const handleCancelOrder = async (orderId) => {
    try {
      console.log(`❌ Cancelling order ${orderId}...`);
      
      // Use the new writerOrderAction function
      await writerOrderAction(orderId, 'cancel');
      
      showSnackbar("Order cancelled successfully!", 'success');
      fetchDashboardData();
      
    } catch (error) {
      console.error('Error cancelling order:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Unknown error';
      showSnackbar(`Failed to cancel order: ${errorMessage}`, 'error');
    }
  };

  // Enhanced file download handler
  const handleDownloadFile = async (fileUrl, fileName, orderId, fileType) => {
    try {
      console.log(`Downloading ${fileType} for order ${orderId}`);
      
      // If we have orderId and fileType, use the specific download function
      if (orderId && fileType) {
        try {
          const result = await downloadOrderFile(orderId, fileType, fileName);
          showSnackbar(`Downloading ${fileName}...`, 'info');
          return result;
        } catch (specificError) {
          console.log('Specific download failed, trying generic:', specificError);
          // Fall back to generic download
        }
      }
      
      // Use generic download function
      await downloadFile(fileUrl, fileName);
      showSnackbar(`Downloading ${fileName}...`, 'info');
    } catch (error) {
      console.error('Download error:', error);
      
      // Fallback to simple download
      try {
        if (!fileUrl) {
          showSnackbar('No file available to download', 'warning');
          return;
        }

        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        const fullUrl = fileUrl.startsWith('http') ? fileUrl : `${baseUrl}${fileUrl}`;
        
        // Add token for authentication
        const token = localStorage.getItem('access_token');
        const urlWithToken = token ? `${fullUrl}?token=${token}` : fullUrl;
        
        // Create and trigger download
        const link = document.createElement('a');
        link.href = urlWithToken;
        link.download = fileName || fileUrl.split('/').pop() || 'download';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        showSnackbar('Download started in new tab...', 'info');
      } catch (fallbackError) {
        console.error('Fallback download also failed:', fallbackError);
        showSnackbar(`Download failed: ${error.message}`, 'error');
      }
    }
  };

  // FIXED: Updated handleSubmitWork function with correct FormData field names
  const handleSubmitWork = async () => {
    try {
      if (!submitWorkData.completedWork) {
        showSnackbar("Please upload the completed work file", 'warning');
        return;
      }
      
      setSubmitWorkData({ ...submitWorkData, isSubmitting: true });
      
      // CORRECT: Create FormData with proper field names that backend expects
      const formData = new FormData();
      
      // Backend expects 'completed_work' (NOT 'file')
      formData.append('completed_work', submitWorkData.completedWork);
      
      // Backend expects 'writer_notes' (NOT 'notes')
      if (submitWorkData.writerNotes) {
        formData.append('writer_notes', submitWorkData.writerNotes);
      }
      
      // Debug log
      console.log("📤 Sending FormData with correct field names:");
      for (let pair of formData.entries()) {
        const key = pair[0];
        const value = pair[1];
        if (value instanceof File) {
          console.log(`${key}: File - ${value.name} (${value.size} bytes)`);
        } else {
          console.log(`${key}: ${value}`);
        }
      }
      
      await submitWork(submitWorkData.orderId, formData);
      
      showSnackbar("Work submitted successfully! Waiting for admin approval.", 'success');
      setSubmitWorkData({
        open: false,
        orderId: null,
        orderTitle: '',
        completedWork: null,
        writerNotes: '',
        isSubmitting: false,
      });
      
      // Refresh data
      fetchDashboardData();
      
    } catch (error) {
      console.error('Error submitting work:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Unknown error';
      showSnackbar(`Failed to submit work: ${errorMessage}`, 'error');
      setSubmitWorkData({ ...submitWorkData, isSubmitting: false });
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check file size (max 50MB)
      if (file.size > 50 * 1024 * 1024) {
        showSnackbar("File size must be less than 50MB", 'warning');
        return;
      }
      
      // Check file type
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'application/zip',
        'application/x-rar-compressed'
      ];
      
      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(pdf|doc|docx|txt|zip|rar)$/i)) {
        showSnackbar("Please upload a valid file type (PDF, DOC, DOCX, TXT, ZIP, RAR)", 'warning');
        return;
      }
      
      setSubmitWorkData({ ...submitWorkData, completedWork: file });
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const closeSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };

  const getStatusColor = (status) => {
    const statusObj = statusTabs.find(tab => tab.value === status);
    return statusObj ? statusObj.color : '#666';
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'PENDING': return <PendingActions />;
      case 'ASSIGNED': return <Assignment />;
      case 'IN_PROGRESS': return <Work />;
      case 'SUBMITTED': return <AssignmentTurnedIn />;
      case 'COMPLETED': return <CheckCircle />;
      case 'REVISION': return <Warning />;
      default: return <AccessTime />;
    }
  };

  const getStatusClassName = (status) => {
    return status.toLowerCase().replace('_', '-');
  };

  const getProgressValue = (status) => {
    const progressMap = {
      'PENDING': 10,
      'ASSIGNED': 30,
      'IN_PROGRESS': 60,
      'SUBMITTED': 80,
      'REVISION': 70,
      'COMPLETED': 100,
      'CANCELLED': 0,
      'CLOSED': 100,
    };
    return progressMap[status] || 0;
  };

  const getUrgentLevel = (deadline) => {
    if (!deadline) return 'normal';
    
    const now = new Date();
    const deadlineDate = new Date(deadline);
    const diffHours = (deadlineDate - now) / (1000 * 60 * 60);
    
    if (diffHours < 24) return 'critical';
    if (diffHours < 48) return 'high';
    if (diffHours < 72) return 'medium';
    return 'normal';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return format(new Date(dateString), 'MMM dd, yyyy HH:mm');
    } catch (error) {
      return 'Invalid date';
    }
  };

  const getTimeRemaining = (deadline) => {
    if (!deadline) return 'No deadline';
    
    const now = new Date();
    const deadlineDate = new Date(deadline);
    const diffMs = deadlineDate - now;
    
    if (diffMs < 0) return 'Overdue';
    
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    
    return `${diffDays}d ${diffHours}h`;
  };

  const getFileIcon = (fileName) => {
    if (!fileName) return <InsertDriveFileIcon />;
    
    const ext = fileName.split('.').pop().toLowerCase();
    switch (ext) {
      case 'pdf': return <PictureAsPdf />;
      case 'doc':
      case 'docx': return <Description />;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif': return <Image />;
      case 'mp4':
      case 'avi':
      case 'mov': return <VideoFile />;
      case 'mp3':
      case 'wav': return <AudioFile />;
      case 'zip':
      case 'rar': return <Archive />;
      default: return <InsertDriveFileIcon />;
    }
  };

  const renderStars = (rating) => {
    if (!rating || rating === 0) return null;
    
    return (
      <Box display="flex" alignItems="center">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            sx={{
              color: i < rating ? '#ffc107' : '#e0e0e0',
              fontSize: '1rem',
            }}
          />
        ))}
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 'bold' }}>
          {rating}/5
        </Typography>
      </Box>
    );
  };

  // Get filtered orders based on active status tab
  const getFilteredOrders = () => {
    const selectedStatus = statusTabs[activeStatusTab].value;
    
    if (selectedStatus === 'ALL') {
      return orders;
    }
    
    return orders.filter(order => order.status === selectedStatus);
  };

  // Get available orders (PENDING and unassigned)
  const getAvailableOrders = () => {
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    return orders.filter(order => 
      order.status === 'PENDING' || 
      (order.status === 'ASSIGNED' && (!order.assigned_to || order.assigned_to === currentUser.id))
    );
  };

  // Get count for each status tab
  const getStatusCount = (status) => {
    if (status === 'ALL') {
      return orders.length;
    }
    
    return orders.filter(order => order.status === status).length;
  };

  // Render Dashboard Tab
  const renderDashboard = () => (
    <Box>
      {/* Welcome Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
        <Box>
          <Typography variant="h4" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '24px', mb: 1 }}>
            Welcome back, Writer!
          </Typography>
          <Typography variant="body1" sx={{ color: '#64748b', fontSize: '15px' }}>
            You have {stats.inProgressOrders} orders in progress • {stats.submittedOrders} submitted for review
          </Typography>
        </Box>
        <OutlineButton
          startIcon={<Refresh />}
          onClick={fetchDashboardData}
        >
          Refresh
        </OutlineButton>
      </Box>

      {/* Stats Overview */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={3}>
          <StatCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Assignment sx={{ color: '#4A6FA5', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Active Orders
                </Typography>
              </Box>
              <Typography variant="h3" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '32px', mb: 1 }}>
                {stats.inProgressOrders}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#10b981' }}>
                <TrendingUp sx={{ fontSize: 16 }} />
                <Typography variant="caption">+2 this week</Typography>
              </Box>
            </CardContent>
          </StatCard>
        </Grid>

        <Grid item xs={12} md={3}>
          <StatCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <AttachMoney sx={{ color: '#4CAF50', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Earnings
                </Typography>
              </Box>
              <Typography variant="h3" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '32px', mb: 1 }}>
                ${stats.totalEarnings.toFixed(0)}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#10b981' }}>
                <TrendingUp sx={{ fontSize: 16 }} />
                <Typography variant="caption">+15% this month</Typography>
              </Box>
            </CardContent>
          </StatCard>
        </Grid>

        <Grid item xs={12} md={3}>
          <StatCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Star sx={{ color: '#FF9800', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Rating
                </Typography>
              </Box>
              <Typography variant="h3" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '32px', mb: 1 }}>
                {stats.avgRating.toFixed(1)}
              </Typography>
              <Box>
                <Typography variant="caption" sx={{ color: '#64748b' }}>
                  Based on {stats.completedOrders} orders
                </Typography>
              </Box>
            </CardContent>
          </StatCard>
        </Grid>

        <Grid item xs={12} md={3}>
          <StatCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Schedule sx={{ color: '#08CB00', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  On-time Delivery
                </Typography>
              </Box>
              <Typography variant="h3" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '32px', mb: 1 }}>
                {stats.onTimeDelivery}%
              </Typography>
              <Box sx={{ mt: 1.5 }}>
                <LinearProgress 
                  variant="determinate" 
                  value={stats.onTimeDelivery}
                  sx={{ 
                    height: 6,
                    borderRadius: 3,
                    backgroundColor: '#e5e7eb',
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: '#08CB00',
                      borderRadius: 3,
                    }
                  }}
                />
              </Box>
            </CardContent>
          </StatCard>
        </Grid>
      </Grid>

      {/* Recent Activity */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <SectionCard>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h6" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '20px' }}>
                  Recent Orders
                </Typography>
                <OutlineButton 
                  size="small"
                  onClick={() => setActiveTab(1)}
                >
                  View All
                </OutlineButton>
              </Box>
              
              <TableContainer>
                <StyledTable size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Order ID</TableCell>
                      <TableCell>Title</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Deadline</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders.slice(0, 5).map((order) => {
                      const urgency = getUrgentLevel(order.deadline);
                      return (
                        <TableRow key={order.id} hover onClick={() => setOrderDetails({ open: true, order })} style={{ cursor: 'pointer' }}>
                          <TableCell>
                            <Typography variant="body2" fontWeight="bold" color="primary">
                              #{order.id}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" noWrap sx={{ maxWidth: 150 }}>
                              {order.title}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={order.status}
                              size="small"
                              icon={getStatusIcon(order.status)}
                              sx={{ 
                                backgroundColor: `${getStatusColor(order.status)}15`,
                                color: getStatusColor(order.status),
                                fontWeight: 600,
                                fontSize: '11px'
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ 
                              display: 'inline-flex', 
                              alignItems: 'center', 
                              gap: 0.5,
                              padding: '4px 8px',
                              borderRadius: 1,
                              fontSize: '12px',
                              fontWeight: 500,
                              ...(urgency === 'critical' && { backgroundColor: '#fee2e2', color: '#dc2626' }),
                              ...(urgency === 'high' && { backgroundColor: '#fef3c7', color: '#d97706' }),
                              ...(urgency === 'medium' && { backgroundColor: '#fef9c3', color: '#ca8a04' }),
                              ...(urgency === 'normal' && { backgroundColor: '#dcfce7', color: '#16a34a' }),
                            }}>
                              <AccessTime sx={{ fontSize: 14 }} />
                              <Typography variant="caption">
                                {getTimeRemaining(order.deadline)}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                              <Tooltip title="View Details">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setOrderDetails({ open: true, order });
                                  }}
                                  sx={{ color: '#666' }}
                                >
                                  <Visibility fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              {order.status === 'ASSIGNED' && (
                                <>
                                  <Tooltip title="Accept Order">
                                    <PrimaryButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleAcceptOrder(order.id);
                                      }}
                                    >
                                      Accept
                                    </PrimaryButton>
                                  </Tooltip>
                                  <Tooltip title="Cancel Order">
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCancelOrder(order.id);
                                      }}
                                      sx={{
                                        color: '#f59e0b',
                                        borderColor: '#f59e0b',
                                        '&:hover': {
                                          backgroundColor: '#fef3c7',
                                          borderColor: '#f59e0b',
                                        }
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </Tooltip>
                                </>
                              )}
                              {order.status === 'IN_PROGRESS' && (
                                <Tooltip title="Submit Work">
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSubmitWorkData({
                                        open: true,
                                        orderId: order.id,
                                        orderTitle: order.title,
                                        completedWork: null,
                                        writerNotes: '',
                                        isSubmitting: false,
                                      });
                                    }}
                                    sx={{
                                      backgroundColor: '#10b981',
                                      color: 'white',
                                      '&:hover': { backgroundColor: '#0da271' },
                                    }}
                                  >
                                    Submit
                                  </Button>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </StyledTable>
              </TableContainer>
            </CardContent>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <SectionCard>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h6" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '20px' }}>
                  Quick Stats
                </Typography>
              </Box>
              
              <List>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ 
                      backgroundColor: '#fff3cd',
                      color: '#856404'
                    }}>
                      <PendingActions />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Pending Review"
                    secondary={`${stats.submittedOrders} orders awaiting admin approval`}
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ 
                      backgroundColor: '#f8d7da',
                      color: '#721c24'
                    }}>
                      <Warning />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Revisions Needed"
                    secondary={`${stats.revisionOrders} orders need revision`}
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ 
                      backgroundColor: '#d4edda',
                      color: '#155724'
                    }}>
                      <CheckCircle />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Completed This Month"
                    secondary={`${Math.floor(stats.completedOrders * 0.3)} orders`}
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ 
                      backgroundColor: '#d1ecf1',
                      color: '#0c5460'
                    }}>
                      <AttachMoney />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Monthly Earnings"
                    secondary={`$${(stats.totalEarnings * 0.3).toFixed(2)}`}
                  />
                </ListItem>
              </List>
            </CardContent>
          </SectionCard>
        </Grid>
      </Grid>
    </Box>
  );

  // Render My Orders Tab
  const renderMyOrders = () => {
    const filteredOrders = getFilteredOrders();
    const selectedStatus = statusTabs[activeStatusTab].value;
    
    return (
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="h5" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '20px' }}>
            My Orders
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <OutlineButton
              startIcon={<Refresh />}
              onClick={fetchDashboardData}
            >
              Refresh Data
            </OutlineButton>
          </Box>
        </Box>

        {/* Status Tabs */}
        <StatusTabsContainer>
          <StatusTabs
            value={activeStatusTab}
            onChange={(e, newValue) => setActiveStatusTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {statusTabs.map((tab, index) => (
              <Tab
                key={index}
                icon={tab.icon}
                iconPosition="start"
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {tab.label}
                    <TabCount>
                      {getStatusCount(tab.value)}
                    </TabCount>
                  </Box>
                }
              />
            ))}
          </StatusTabs>
          
          <Box sx={{ p: 2 }}>
            {/* Orders Table */}
            <TableContainer>
              <StyledTable>
                <TableHead>
                  <TableRow>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Subject</TableCell>
                    <TableCell>Pages</TableCell>
                    <TableCell>Budget</TableCell>
                    <TableCell>Deadline</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredOrders.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                        <Box sx={{ textAlign: 'center' }}>
                          <Assignment sx={{ fontSize: 60, color: '#e0e0e0', mb: 2 }} />
                          <Typography variant="h6" sx={{ color: 'text.secondary', mb: 1 }}>
                            No orders found
                          </Typography>
                          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
                            {selectedStatus === 'ALL' 
                              ? "You have no orders assigned to you."
                              : `No orders with status: ${selectedStatus}`
                            }
                          </Typography>
                          <PrimaryButton 
                            onClick={() => setActiveTab(2)}
                          >
                            Check Available Orders
                          </PrimaryButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredOrders.map((order) => {
                      const urgency = getUrgentLevel(order.deadline);
                      return (
                        <TableRow key={order.id} hover>
                          <TableCell>
                            <Typography variant="body2" fontWeight="bold" color="primary">
                              #{order.id}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                              {order.title}
                            </Typography>
                          </TableCell>
                          <TableCell>{order.subject || 'General'}</TableCell>
                          <TableCell>{order.pages}</TableCell>
                          <TableCell>
                            <Typography variant="body2" fontWeight="bold" sx={{ color: '#08CB00' }}>
                              ${parseFloat(order.budget || 0).toFixed(2)}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography variant="body2">
                                {formatDate(order.deadline)}
                              </Typography>
                              <DeadlineChip
                                size="small"
                                label={getTimeRemaining(order.deadline)}
                                urgency={urgency}
                                sx={{ mt: 0.5 }}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={order.status}
                              icon={getStatusIcon(order.status)}
                              sx={{ 
                                backgroundColor: `${getStatusColor(order.status)}15`,
                                color: getStatusColor(order.status),
                                fontWeight: 600,
                                fontSize: '11px'
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                              <Tooltip title="View Details">
                                <IconButton
                                  size="small"
                                  onClick={() => setOrderDetails({ open: true, order })}
                                  sx={{ color: '#666' }}
                                >
                                  <Visibility fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              
                              {order.status === 'ASSIGNED' && (
                                <>
                                  <Tooltip title="Accept Order">
                                    <PrimaryButton
                                      size="small"
                                      startIcon={<CheckCircle />}
                                      onClick={() => {
                                        if (window.confirm(`Accept order #${order.id}?`)) {
                                          handleAcceptOrder(order.id);
                                        }
                                      }}
                                    >
                                      Accept
                                    </PrimaryButton>
                                  </Tooltip>
                                  <Tooltip title="Cancel Order">
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      startIcon={<Cancel />}
                                      onClick={() => {
                                        if (window.confirm(`Cancel order #${order.id}? This will return it to available orders.`)) {
                                          handleCancelOrder(order.id);
                                        }
                                      }}
                                      sx={{
                                        color: '#f59e0b',
                                        borderColor: '#f59e0b',
                                        '&:hover': {
                                          backgroundColor: '#fef3c7',
                                          borderColor: '#f59e0b',
                                        }
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </Tooltip>
                                </>
                              )}
                              
                              {order.status === 'IN_PROGRESS' && (
                                <Tooltip title="Submit Work">
                                  <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<CheckCircle />}
                                    onClick={() => {
                                      setSubmitWorkData({
                                        open: true,
                                        orderId: order.id,
                                        orderTitle: order.title,
                                        completedWork: null,
                                        writerNotes: '',
                                        isSubmitting: false,
                                      });
                                    }}
                                    sx={{
                                      backgroundColor: '#10b981',
                                      color: 'white',
                                      '&:hover': { backgroundColor: '#0da271' },
                                    }}
                                  >
                                    Submit
                                  </Button>
                                </Tooltip>
                              )}
                              
                              {order.status === 'REVISION' && (
                                <Tooltip title="Re-submit Work">
                                  <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<Edit />}
                                    onClick={() => {
                                      setSubmitWorkData({
                                        open: true,
                                        orderId: order.id,
                                        orderTitle: order.title,
                                        completedWork: null,
                                        writerNotes: '',
                                        isSubmitting: false,
                                      });
                                    }}
                                    sx={{
                                      backgroundColor: '#f59e0b',
                                      color: 'white',
                                      '&:hover': { backgroundColor: '#d97706' },
                                    }}
                                  >
                                    Re-submit
                                  </Button>
                                </Tooltip>
                              )}
                              
                              {order.status === 'COMPLETED' && order.completed_work && (
                                <Tooltip title="Download Work">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDownloadFile(
                                      order.completed_work, 
                                      `order_${order.id}_completed_work`,
                                      order.id,
                                      'completed_work'
                                    )}
                                    sx={{ color: '#08CB00' }}
                                  >
                                    <Download fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </StyledTable>
            </TableContainer>
          </Box>
        </StatusTabsContainer>
      </Box>
    );
  };

  // Render Available Orders Tab
  const renderAvailableOrders = () => {
    const availableOrders = getAvailableOrders();
    
    return (
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h5" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '20px' }}>
            Available Orders
          </Typography>
          <OutlineButton
            startIcon={<Refresh />}
            onClick={fetchDashboardData}
          >
            Refresh
          </OutlineButton>
        </Box>

        <SectionCard>
          <CardContent>
            <TableContainer>
              <StyledTable>
                <TableHead>
                  <TableRow>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Subject</TableCell>
                    <TableCell>Pages</TableCell>
                    <TableCell>Budget</TableCell>
                    <TableCell>Deadline</TableCell>
                    <TableCell>Academic Level</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {availableOrders.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                        <Box sx={{ textAlign: 'center' }}>
                          <Assignment sx={{ fontSize: 60, color: '#e0e0e0', mb: 2 }} />
                          <Typography variant="h6" sx={{ color: 'text.secondary', mb: 1 }}>
                            No available orders
                          </Typography>
                          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
                            All pending orders have been assigned or there are no new orders.
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    availableOrders.map((order) => {
                      const urgency = getUrgentLevel(order.deadline);
                      return (
                        <TableRow key={order.id} hover sx={{ '&:hover': { backgroundColor: '#F0FFF0' } }}>
                          <TableCell>
                            <Typography variant="body2" fontWeight="bold" color="primary">
                              #{order.id}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                              {order.title}
                            </Typography>
                          </TableCell>
                          <TableCell>{order.subject || 'General'}</TableCell>
                          <TableCell>{order.pages}</TableCell>
                          <TableCell>
                            <Typography variant="body2" fontWeight="bold" sx={{ color: '#08CB00' }}>
                              ${parseFloat(order.budget || 0).toFixed(2)}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography variant="body2">
                                {formatDate(order.deadline)}
                              </Typography>
                              <DeadlineChip
                                size="small"
                                label={getTimeRemaining(order.deadline)}
                                urgency={urgency}
                                sx={{ mt: 0.5 }}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={order.academic_level || 'High School'}
                              size="small"
                              variant="outlined"
                              sx={{ borderColor: '#08CB00', color: '#08CB00' }}
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                              <Tooltip title="View Details">
                                <IconButton
                                  size="small"
                                  onClick={() => setOrderDetails({ open: true, order })}
                                  sx={{ color: '#666' }}
                                >
                                  <Visibility fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              
                              {order.status === 'PENDING' && (
                                <Tooltip title="Request Assignment">
                                  <PrimaryButton
                                    size="small"
                                    startIcon={<Assignment />}
                                    onClick={() => {
                                      if (window.confirm(`Request assignment for order #${order.id}?`)) {
                                        // Note: This would need a separate "request assignment" API endpoint
                                        showSnackbar('Request assignment functionality would need to be implemented in the backend', 'info');
                                      }
                                    }}
                                  >
                                    Request
                                  </PrimaryButton>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </StyledTable>
            </TableContainer>
          </CardContent>
        </SectionCard>
      </Box>
    );
  };

  // Render Messages Tab
  const renderMessages = () => (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" sx={{ color: '#1e293b', fontWeight: 700, fontSize: '20px' }}>
          <Message sx={{ mr: 1, color: '#08CB00' }} /> Messaging Center
        </Typography>
        <OutlineButton 
          startIcon={<Refresh />}
          onClick={fetchDashboardData}
        >
          Refresh
        </OutlineButton>
      </Box>
      
      <SectionCard>
        <CardContent>
          <MessagingCenter />
        </CardContent>
      </SectionCard>
    </Box>
  );

  // Enhanced Order Details Dialog with ALL database fields (Writer version)
  const renderOrderDetailsDialog = () => {
    if (!orderDetails.order) return null;
    
    const order = orderDetails.order;
    
    return (
      <Dialog
        open={orderDetails.open}
        onClose={() => setOrderDetails({ ...orderDetails, open: false })}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          className: 'admin-dialog large-dialog',
          sx: { borderRadius: 12 }
        }}
      >
        <div style={{ 
          padding: '20px 24px 12px', 
          borderBottom: '1px solid #e5e7eb', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          <Typography variant="h6" style={{ 
            color: '#1e293b', 
            fontWeight: 600, 
            fontSize: '18px', 
            margin: 0,
            display: 'flex',
            alignItems: 'center'
          }}>
            <Assignment sx={{ mr: 1 }} />
            Order #{order.id}: {order.title}
          </Typography>
          <IconButton 
            size="small"
            onClick={() => setOrderDetails({ ...orderDetails, open: false })}
          >
            <Cancel />
          </IconButton>
        </div>
        
        <DialogContent dividers>
          {/* Order Progress Bar */}
          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="body2" color="text.secondary">
                Order Progress
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {getProgressValue(order.status)}%
              </Typography>
            </Box>
            <LinearProgress 
              variant="determinate" 
              value={getProgressValue(order.status)} 
              sx={{ height: 8, borderRadius: 4 }}
            />
          </Box>
          
          <Grid container spacing={3}>
            {/* Left Column - Order Information */}
            <Grid item xs={12} md={6}>
              {/* Order Status & Basic Info */}
              <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                  <Assignment fontSize="small" sx={{ mr: 1 }} />
                  Order Status & Basic Info
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Status:</Typography>
                    <Chip
                      className={`status-badge ${getStatusClassName(order.status)}`}
                      icon={getStatusIcon(order.status)}
                      label={order.status}
                      sx={{ mt: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Revision Count:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.revision_count || 0}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Order ID:</Typography>
                    <Typography variant="body1" fontWeight="bold" sx={{ mt: 0.5 }}>
                      #{order.id}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Budget:</Typography>
                    <Typography variant="body1" fontWeight="bold" color="primary" sx={{ mt: 0.5 }}>
                      ${parseFloat(order.budget || 0).toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              {/* Order Specifications */}
              <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                  <Description fontSize="small" sx={{ mr: 1 }} />
                  Order Specifications
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Subject:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.subject || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Academic Level:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.academic_level || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Pages:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.pages}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Word Count (est.):</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {(order.pages || 0) * 275} words
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Language:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.language || 'English'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Format:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.format || 'APA'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Spacing:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.spacing || 'Double'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Slides:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.slides || 0}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Sources:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.sources || 0}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              {/* Additional Services */}
              <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                  <AttachMoney fontSize="small" sx={{ mr: 1 }} />
                  Additional Services
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Chip
                      size="small"
                      icon={order.plagiarism_report ? <Check /> : <Close />}
                      label="Plagiarism Report"
                      color={order.plagiarism_report ? "success" : "default"}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Chip
                      size="small"
                      icon={order.executive_summary ? <Check /> : <Close />}
                      label="Executive Summary"
                      color={order.executive_summary ? "success" : "default"}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Chip
                      size="small"
                      icon={order.expert_writer ? <Check /> : <Close />}
                      label="Expert Writer"
                      color={order.expert_writer ? "success" : "default"}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Right Column - Timelines & Files */}
            <Grid item xs={12} md={6}>
              {/* Timelines */}
              <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                  <Schedule fontSize="small" sx={{ mr: 1 }} />
                  Timelines
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Created At:</Typography>
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      {formatDate(order.created_at)}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Last Updated:</Typography>
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      {formatDate(order.updated_at)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Deadline:</Typography>
                    <Box sx={{ mt: 0.5 }}>
                      <Typography variant="body2">
                        {formatDate(order.deadline)}
                      </Typography>
                      <Chip
                        size="small"
                        label={getTimeRemaining(order.deadline)}
                        className={`time-display ${getUrgentLevel(order.deadline)}`}
                        sx={{ mt: 0.5 }}
                      />
                    </Box>
                  </Grid>
                  {order.completed_at && (
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Completed At:</Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {formatDate(order.completed_at)}
                      </Typography>
                    </Grid>
                  )}
                  {order.revision_requested_at && (
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Revision Requested:</Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {formatDate(order.revision_requested_at)}
                      </Typography>
                    </Grid>
                  )}
                  {order.rated_at && (
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }}>Rated At:</Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {formatDate(order.rated_at)}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Paper>

              {/* Files Section */}
              <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                  <Folder fontSize="small" sx={{ mr: 1 }} />
                  Files & Attachments
                </Typography>
                
                {/* Client Uploaded Files */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" fontWeight="medium" gutterBottom>
                    <AttachFile fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Client Uploaded Files:
                  </Typography>
                  {order.files ? (
                    <Button
                      variant="outlined"
                      startIcon={getFileIcon(order.files)}
                      fullWidth
                      onClick={() => handleDownloadFile(
                        order.files, 
                        `order_${order.id}_client_files`,
                        order.id,
                        'client_files'
                      )}
                      sx={{ justifyContent: 'flex-start' }}
                    >
                      Download Client Files
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No files uploaded by client
                    </Typography>
                  )}
                </Box>
                
                {/* Writer Submitted Work */}
                <Box>
                  <Typography variant="body2" fontWeight="medium" gutterBottom>
                    <FileCopy fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Writer Submitted Work:
                  </Typography>
                  {order.completed_work ? (
                    <Button
                      variant="contained"
                      startIcon={<CloudDownload />}
                      fullWidth
                      onClick={() => handleDownloadFile(
                        order.completed_work, 
                        `order_${order.id}_completed_work`,
                        order.id,
                        'completed_work'
                      )}
                      sx={{ justifyContent: 'flex-start', backgroundColor: '#08CB00', '&:hover': { backgroundColor: '#07B300' } }}
                    >
                      Download Completed Work
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No work submitted yet
                    </Typography>
                  )}
                </Box>
              </Paper>

              {/* Rating & Review (Only show if rated) */}
              {order.rating && (
                <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                    <Star fontSize="small" sx={{ mr: 1 }} />
                    Client Rating & Review
                  </Typography>
                  <Box>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mb: 0.5 }} gutterBottom>
                      Rating:
                    </Typography>
                    {renderStars(order.rating)}
                    {order.client_review && (
                      <>
                        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', mt: 2, mb: 0.5 }} gutterBottom>
                          Review:
                        </Typography>
                        <Paper variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                          <Typography variant="body2">
                            {order.client_review}
                          </Typography>
                        </Paper>
                      </>
                    )}
                  </Box>
                </Paper>
              )}
            </Grid>

            {/* Full Width Sections */}
            <Grid item xs={12}>
              {/* Instructions */}
              <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                  <Notes fontSize="small" sx={{ mr: 1 }} />
                  Instructions
                </Typography>
                <Paper variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1, minHeight: 100 }}>
                  <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                    {order.instructions || 'No instructions provided'}
                  </Typography>
                </Paper>
              </Paper>
            </Grid>

            {/* Writer Notes */}
            {order.writer_notes && (
              <Grid item xs={12}>
                <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                    <Comment fontSize="small" sx={{ mr: 1 }} />
                    Your Notes
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2, bgcolor: 'info.light', borderRadius: 1 }}>
                    <Typography variant="body2">
                      {order.writer_notes}
                    </Typography>
                  </Paper>
                </Paper>
              </Grid>
            )}

            {/* Revision Notes */}
            {order.revision_notes && (
              <Grid item xs={12}>
                <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: 1, border: '1px solid #e5e7eb' }}>
                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                    <Feedback fontSize="small" sx={{ mr: 1 }} />
                    Revision Notes
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2, bgcolor: 'warning.light', borderRadius: 1 }}>
                    <Typography variant="body2" color="warning.dark">
                      {order.revision_notes}
                    </Typography>
                  </Paper>
                </Paper>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        
        <div style={{ 
          padding: '16px 24px', 
          borderTop: '1px solid #e5e7eb', 
          display: 'flex', 
          gap: 2, 
          justifyContent: 'flex-end' 
        }}>
          <Button 
            variant="outlined"
            onClick={() => setOrderDetails({ ...orderDetails, open: false })}
            sx={{
              backgroundColor: 'white',
              color: '#08CB00',
              border: '1px solid #08CB00',
              '&:hover': {
                backgroundColor: '#F0FFF0',
              }
            }}
          >
            Close
          </Button>
          {order.status === 'ASSIGNED' && (
            <>
              <PrimaryButton
                onClick={() => {
                  setOrderDetails({ ...orderDetails, open: false });
                  setTimeout(() => {
                    handleAcceptOrder(order.id);
                  }, 100);
                }}
              >
                Accept Order
              </PrimaryButton>
              <Button
                variant="outlined"
                onClick={() => {
                  setOrderDetails({ ...orderDetails, open: false });
                  setTimeout(() => {
                    if (window.confirm(`Cancel order #${order.id}? This will return it to available orders.`)) {
                      handleCancelOrder(order.id);
                    }
                  }, 100);
                }}
                sx={{
                  color: '#f59e0b',
                  borderColor: '#f59e0b',
                  '&:hover': {
                    backgroundColor: '#fef3c7',
                    borderColor: '#f59e0b',
                  }
                }}
              >
                Cancel Order
              </Button>
            </>
          )}
          {order.status === 'IN_PROGRESS' && (
            <PrimaryButton
              onClick={() => {
                setOrderDetails({ ...orderDetails, open: false });
                setTimeout(() => {
                  setSubmitWorkData({
                    open: true,
                    orderId: order.id,
                    orderTitle: order.title,
                    completedWork: null,
                    writerNotes: '',
                    isSubmitting: false,
                  });
                }, 100);
              }}
            >
              Submit Work
            </PrimaryButton>
          )}
          {order.status === 'REVISION' && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#f59e0b',
                color: 'white',
                '&:hover': { backgroundColor: '#d97706' },
              }}
              onClick={() => {
                setOrderDetails({ ...orderDetails, open: false });
                setTimeout(() => {
                  setSubmitWorkData({
                    open: true,
                    orderId: order.id,
                    orderTitle: order.title,
                    completedWork: null,
                    writerNotes: '',
                    isSubmitting: false,
                  });
                }, 100);
              }}
            >
              Re-submit Work
            </Button>
          )}
        </div>
      </Dialog>
    );
  };

  // Submit Work Dialog
  const renderSubmitDialog = () => (
    <CustomDialog
      open={submitWorkData.open}
      onClose={() => !submitWorkData.isSubmitting && setSubmitWorkData({
        open: false,
        orderId: null,
        orderTitle: '',
        completedWork: null,
        writerNotes: '',
        isSubmitting: false,
      })}
      PaperProps={{
        className: 'admin-dialog'
      }}
      maxWidth="sm"
      fullWidth
    >
      <Box sx={{ p: '20px 24px 12px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" sx={{ color: '#1e293b', fontWeight: 600, fontSize: '18px', m: 0 }}>
          Submit Work for Order #{submitWorkData.orderId}
        </Typography>
        {!submitWorkData.isSubmitting && (
          <IconButton 
            size="small"
            onClick={() => setSubmitWorkData({
              open: false,
              orderId: null,
              orderTitle: '',
              completedWork: null,
              writerNotes: '',
              isSubmitting: false,
            })}
          >
            <Cancel />
          </IconButton>
        )}
      </Box>
      
      <DialogContent>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
          {submitWorkData.orderTitle}
        </Typography>
        
        {submitWorkData.isSubmitting ? (
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <CircularProgress />
            <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
              Submitting work...
            </Typography>
          </Box>
        ) : (
          <>
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontWeight: 'bold', mb: 1, fontSize: '14px' }}>Upload Completed Work</Typography>
              <Button
                variant="outlined"
                component="label"
                startIcon={<Download />}
                fullWidth
                sx={{ mb: 2 }}
              >
                {submitWorkData.completedWork 
                  ? `File: ${submitWorkData.completedWork.name}` 
                  : 'Choose File'}
                <input
                  type="file"
                  hidden
                  onChange={handleFileUpload}
                />
              </Button>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Accepted formats: PDF, DOC, DOCX, TXT, ZIP, RAR (max 50MB)
              </Typography>
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontWeight: 'bold', mb: 1, fontSize: '14px' }}>Notes to Admin (Optional)</Typography>
              <TextField
                multiline
                rows={4}
                fullWidth
                placeholder="Add any notes about your submission..."
                value={submitWorkData.writerNotes}
                onChange={(e) => setSubmitWorkData({ ...submitWorkData, writerNotes: e.target.value })}
                variant="outlined"
                size="small"
              />
            </Box>
            
            {submitWorkData.completedWork && (
              <Alert severity="info" sx={{ 
                mb: 2,
                '& .MuiAlert-icon': { color: '#08CB00' }
              }}>
                <Typography variant="body2">
                  Ready to submit: {submitWorkData.completedWork.name} 
                  ({(submitWorkData.completedWork.size / 1024 / 1024).toFixed(2)} MB)
                </Typography>
              </Alert>
            )}
          </>
        )}
      </DialogContent>
      
      <Box sx={{ p: '16px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        {!submitWorkData.isSubmitting && (
          <>
            <Button 
              sx={{ color: '#666' }}
              onClick={() => setSubmitWorkData({
                open: false,
                orderId: null,
                orderTitle: '',
                completedWork: null,
                writerNotes: '',
                isSubmitting: false,
              })}
            >
              Cancel
            </Button>
            <PrimaryButton
              onClick={handleSubmitWork}
              disabled={!submitWorkData.completedWork}
            >
              Submit Work
            </PrimaryButton>
          </>
        )}
      </Box>
    </CustomDialog>
  );

  // Snackbar component
  const renderSnackbar = () => (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={closeSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert 
        onClose={closeSnackbar} 
        severity={snackbar.severity}
        sx={{ width: '100%' }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );

  if (loading) {
    return (
      <DashboardContainer>
        <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <Box sx={{ textAlign: 'center' }}>
            <CircularProgress sx={{ color: '#08CB00', mb: 3 }} />
            <Typography variant="h6" sx={{ color: 'text.secondary' }}>
              Loading Writer Dashboard...
            </Typography>
          </Box>
        </Container>
      </DashboardContainer>
    );
  }

  return (
    <DashboardContainer>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header */}
        <DashboardHeader>
          <Box>
            <Typography variant="h4" sx={{ 
              color: '#1e293b',
              margin: 0,
              fontWeight: 700,
              fontSize: '28px',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              lineHeight: 1.3
            }}>
              <Dashboard sx={{ color: '#08CB00' }} />
              Writer Dashboard
            </Typography>
            <Typography variant="body1" sx={{ 
              color: '#64748b',
              fontSize: '15px',
              mt: 0.5,
              fontWeight: 400
            }}>
              Manage your assigned orders and submit completed work
            </Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1.5, 
            p: '8px 16px', 
            backgroundColor: '#f8fafc', 
            borderRadius: 2,
            border: '1px solid #e5e7eb'
          }}>
            <Avatar sx={{ bgcolor: '#08CB00', width: 40, height: 40 }}>
              <AccountCircle />
            </Avatar>
            <Box>
              <Typography variant="body2" fontWeight="bold">
                Writer Account
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                ${stats.totalEarnings.toFixed(0)} earned
              </Typography>
            </Box>
          </Box>
        </DashboardHeader>
        
        {/* Main Tabs */}
        <MainTabsContainer>
          <StyledTabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((tab, index) => (
              <StyledTab
                key={index}
                icon={tab.icon}
                iconPosition="start"
                label={tab.label}
              />
            ))}
          </StyledTabs>
          
          {/* Content Panel */}
          <ContentPanel>
            {activeTab === 0 && renderDashboard()}
            {activeTab === 1 && renderMyOrders()}
            {activeTab === 2 && renderAvailableOrders()}
            {activeTab === 3 && renderMessages()}
          </ContentPanel>
        </MainTabsContainer>
      </Container>
      
      {/* Dialogs */}
      {renderSubmitDialog()}
      {renderOrderDetailsDialog()}
      
      {/* Snackbar for notifications */}
      {renderSnackbar()}
    </DashboardContainer>
  );
};

export default WriterDashboard;